export { MailboxQuotaItem as default };

class MailboxQuotaItem{
   /**
   * Quota Messages Limit
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  messages_limit = 0;

   /**
   * Current number of Messages used
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  messages_used = 0;

   /**
   * Current messages percentage
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  messages_percentage = 0;

   /**
   * Quota space used in GB
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_used = 0;

   /**
   * Quota space used in GB
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_used_gb = 0;

   /**
   * Storage Limit in GB
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
   storage_limit = 0;

  /**
   * Storage Limit in GB
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_limt_gb = 0;

   /**
   * Occupied Storage percentage
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_percentage = 0;

  storage_percentage_bar = 0;

  /**
   * Virtual Storage Limit in GB
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_virtual = 0;

  storage_virtual_percentage = 0;

  /**
   * Virtual Storage Limit in GB
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_virtual_gb = 0;

   /**
   * Occupied Storage Percentage Floor
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  storage_percentage_floor = 0;
}